import { axiosInstance } from '@/modules/shared/lib/axios';
import { PrintoutConfigurationModel } from './types';

type Props = {
  companyId: string
}

export function getPrintoutConfiguration({ companyId }: Props) {
  return axiosInstance.get<PrintoutConfigurationModel>(`/api/${companyId}/configuration/printout`);
}
